import React, { Fragment } from "react";
import styles from "./loader.module.scss";
export const FullPageLoader = () => {
  return <div className={styles.loading}>Loading&#8230;</div>;
};

export default FullPageLoader;
